export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hoppla, da ist ein Fehler aufgetreten!"])}
}